var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"preview-img"},_vm._l((_vm.showImgList),function(img,index){return _c('li',{key:index},[_c('el-image',{ref:"elImage",refInFor:true,attrs:{"src":img,"fit":"cover","preview-src-list":_vm.previewList}}),_c('div',{staticClass:"tips",on:{"click":function($event){return _vm.previewImg(index)}}},[_vm._v("查看大图")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }